import { OfficeButton, PopUp } from "components";
import { ReinstateFacOffer, ReinstateFacOfferVariables } from "_graphql/kek/mutation/__generated__/ReinstateFacOffer";

import { LocationGenerics } from "router/location";
import { reinstateFacOffer } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function ReinstateContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<ReinstateFacOffer, ReinstateFacOfferVariables>(
    reinstateFacOffer,
    {
      refetchQueries: ["KEKOffers"],
    }
  );

  const handleSubmit = async () => {
    await remove({
      variables: {
        offerId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.reinstateFacOffer) {
        toast.success("Offer Reinstated Successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Could not reinstate offer");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Reinstate Offer"
      cancelText="No, Don't Reinstate Offer"
      variant="warning"
      description="This action would reinstate offer details for editing"
      renderActions={() => (
        <>
          <OfficeButton
            variant="warning"
            size="sm"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "Reinstating Offer..." : "Reinstate Offer"}
          </OfficeButton>
        </>
      )}
    />
  );
}
